import { Injectable } from '@angular/core';
import { catchError, retry } from 'rxjs/internal/operators';
import { Observable, throwError } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { RuntimeConfigLoaderService } from 'runtime-config-loader';
import { GlobalSearchService } from '../services/globalsearchservice.service';
@Injectable({
	providedIn: 'root'
})

export class DashboardService {
	key = 'UET6DFMPAXW7BKCB';
	config: any;
	user: any = [];
	package: any = '';

	constructor(private http: HttpClient, private _configSvc: RuntimeConfigLoaderService, public globalSearchService: GlobalSearchService) {
		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
		})

		this.globalSearchService.user.subscribe((result) => {
			this.user = result;
		});

	}

	public httpOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json',
		})
	};

	public getOptions = {
		headers: new HttpHeaders({

		})
	};

	public login(input) {
		localStorage.setItem('user', JSON.stringify(input));
		return true;
	}

	public logout() {
		localStorage.removeItem('user');
		return true;
	}

	public getDashBoard() {
		const method = 'dashboard' + this.getKey();
		return this.http.get(this.setEndPoint(method), this.getOptions);
	}

	public getNegative() {
		const method = 'dashboard/negativeinv' + this.getKey();
		return this.http.get(this.setEndPoint(method), this.getOptions);
	}

	public getNeedLocation() {
		const method = 'dashboard/needloc' + this.getKey();
		return this.http.get(this.setEndPoint(method), this.getOptions);
	}

	public getCatAndLines() {
		const method = 'dashboard/getcatandlines' + this.getKey();
		return this.http.get(this.setEndPoint(method), this.getOptions);
	}

	public getThisYearOverLast(filters: any = {}) {
		const method = 'dashboard/thisoverlast' + '&yearCount=' + filters.yearCount + this.getKey();
		return this.http.get(this.setEndPoint(method), this.getOptions);
	}

	public getThisYearOverLastSalesman(data: any) {
		const method = 'dashboard/thisoverlast' + this.getKey();
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	public getThisMonthOverLast(data) {
		const method = 'dashboard/daybyday';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	public getThisDayOverLast(data) {
		const method = 'dashboard/daysales';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	public getSalesmanData(data:any) {
		const method = 'salesman/dashboard' + this.getKey();
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	public getSalesmanKpis(period?: { kpis_primary_ym: string; kpis_compare_ym: string } | null) {
		let method = 'dashboard/salesmankpis' + this.getKey();
		if (period?.kpis_primary_ym && period?.kpis_compare_ym) {
			method += '&kpis_primary_ym=' + encodeURIComponent(period.kpis_primary_ym)
				+ '&kpis_compare_ym=' + encodeURIComponent(period.kpis_compare_ym);
		}
		return this.http.get(this.setEndPoint(method), this.getOptions).pipe(
			catchError(this.handleError(method))
		);
	}

	public getOpenCOunt() {
		const method = 'dashboard/openorders' + this.getKey();
		return this.http.get(this.setEndPoint(method), this.getOptions);
	}

	/**
	 * Splits a canonical open-order list into age buckets (days since
	 * DATE_ORDERED) and a "not due" bucket (DATE_WANTED is today or later).
	 *   bucket1: 3-5 days old
	 *   bucket2: 5-7 days old
	 *   bucket3: >7 days old
	 *   notdue:  DATE_WANTED in the future (or today), deduped by orderno
	 */
	public computeOpenOrderAgeBuckets(rows: any[]): { bucket1: any[]; bucket2: any[]; bucket3: any[]; notdue: any[] } {
		const bucket1: any[] = [];
		const bucket2: any[] = [];
		const bucket3: any[] = [];
		const notdue: any[] = [];
		const notdueSeen = new Set<any>();

		const now = new Date();
		const today = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
		const msPerDay = 1000 * 60 * 60 * 24;

		const parseDate = (raw: any): Date | null => {
			if (!raw) { return null; }
			if (typeof raw === 'string') {
				const normalized = raw.replace(' ', 'T');
				const d = new Date(normalized);
				if (!isNaN(d.getTime())) { return d; }
				const d2 = new Date(raw);
				return isNaN(d2.getTime()) ? null : d2;
			}
			const d = new Date(raw);
			return isNaN(d.getTime()) ? null : d;
		};

		for (const row of rows) {
			const ordered = parseDate(row.DATE_ORDERED || row.orddate || row.date_created);
			if (ordered) {
				const orderedDay = new Date(ordered.getFullYear(), ordered.getMonth(), ordered.getDate()).getTime();
				const daysOld = Math.floor((today - orderedDay) / msPerDay);
				if (daysOld >= 3 && daysOld < 5) {
					bucket1.push(row);
				} else if (daysOld >= 5 && daysOld < 7) {
					bucket2.push(row);
				} else if (daysOld >= 7) {
					bucket3.push(row);
				}
			}

			const wanted = parseDate(row.DATE_WANTED || row.deliverydate);
			if (wanted) {
				const wantedDay = new Date(wanted.getFullYear(), wanted.getMonth(), wanted.getDate()).getTime();
				if (wantedDay >= today) {
					const key = row.orderno ?? row.ORDER_NUMBER;
					if (key !== undefined && !notdueSeen.has(key)) {
						notdueSeen.add(key);
						notdue.push(row);
					} else if (key === undefined) {
						notdue.push(row);
					}
				}
			}
		}

		return { bucket1, bucket2, bucket3, notdue };
	}

	public getOrderCountByDay() {
		const method = 'dashboard/getordercountbyday' + this.getKey();
		return this.http.get(this.setEndPoint(method), this.getOptions);
	}

	public getReceievedTotalByDay() {
		const method = 'dashboard/getposcountbyday' + this.getKey();
		return this.http.get(this.setEndPoint(method), this.getOptions);
	}

	public getTaxOrders() {
		const method = 'dashboard/gettaxorders' + this.getKey();
		return this.http.get(this.setEndPoint(method), this.getOptions);
	}

	public getNonStockData(label) {
		const method = 'dashboard/getnonstocks' +'&label='+ label + this.getKey();
		return this.http.get(this.setEndPoint(method), this.getOptions);
	}

	private setEndPoint(method: any) {
		return this.getApi() + method + this.getApiKey()
	}

	private getApi() {
		return this.config.apiServer.endpoint;
	}

	private getApiKey() {
		return '&key=' + this.config.apiCredentials.clientId + '&userid=' + this.user.user.userid + this.getPackage();
	}

	public getBrandReport(data:any) {		
		const method = data.vendor ? 'dashboard/vendorbrandbylocation' : 'dashboard/brandbylocation';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	private getPackage() {
		const p = this.globalSearchService.getSessionItem('package');
		if(p) {
			return '&package='+p;
		} else {
			return '';
		}
	}

	public getKey() {
		return '&apikey=' + this.key;
	}

	private handleError<T>(operation = 'operation', result?: T) {

		return (error: any): Observable<T> => {

			if (error instanceof HttpErrorResponse && error.status === 401) {
				window.location.href = '/#/auth/logout';
			}

			return throwError(() => error);
		};
	}

}
